import { Drawer, Typography, Space, Steps, Table, Divider, Badge } from 'antd';
import { COLUMN_EXTRA_SMALL, COLUMN_MEDIUM } from 'constants/table';
import dayjs from 'dayjs';
import { paymentTypes } from 'utils/handbooks/paymentsHandbook';
import { priceRender } from 'utils/table';
import 'dayjs/locale/ru';
import { bccNestedColumns } from 'components/PaymentsInfoTables/datasource';
import { useState } from 'react';
import { StepsContainer } from './style';

dayjs.locale('ru');

function PayedTaxesDrawer({
  open,
  onClose,
  title,
  activeRecord,
  paymentsInfo,
}) {
  const statuses = {
    SUCCESS: 'Успешно',
    ERROR: 'Ошибка',
  };
  const statusColor = {
    SUCCESS: 'green',
    ERROR: 'red',
  };
  const statusColorText = {
    SUCCESS: 'success',
    ERROR: 'danger',
  };
  const statusesNames = {
    SENT_TRANSIT: 'Отправлен',
    ERROR_SENT_TRANSIT: 'Отправлен',
    SENT_TRANSIT_VISA: 'Cкидка от Visa',
    ERROR_SENT_TRANSIT_VISA: 'Cкидка от Visa',
    PAID: 'Оплачен',
    SUCCESS: 'Полностью проведён',
    CREATED: 'Сформирован',
    ERROR_SEND_ALL: 'Не проведен',
    PARTLY_SUCCESS: 'Частично проведен',
  };

  const stepsData = paymentsInfo?.statuses?.map(
    ({ index, status, status_name, description, date }) => {
      return {
        title: (
          <Space.Compact
            direction="vertical"
            style={{ position: 'relative', overflow: 'visible' }}
          >
            <Space style={{ position: 'absolute', top: '-28px' }}>
              <Badge color={statusColor[status]} />
              <Typography.Text type={statusColorText[status]}>
                {statuses[status]}
              </Typography.Text>
            </Space>
            <Typography.Text style={{ fontWeight: 'bold' }}>
              {statusesNames[status_name]}
            </Typography.Text>
          </Space.Compact>
        ),
        description: (
          <Space direction="vertical">
            <Typography.Text type={status === 'ERROR' && 'danger'}>
              {dayjs(date).format('DD MMMM YYYY, hh:mm')}
            </Typography.Text>
            <Typography.Text type={status === 'ERROR' ? 'danger' : 'secondary'}>
              {description}
            </Typography.Text>
          </Space>
        ),
        date,
        status_name,
        index,
        status: 'finished',
      };
    }
  );

  const columns = [
    {
      width: COLUMN_MEDIUM,
      dataIndex: 'type',
      title: 'Налоги',
      key: 'type',
      render: (text) => paymentTypes[text] ?? '---',
    },
    {
      width: COLUMN_MEDIUM,
      dataIndex: 'period',
      title: 'Период',
      key: 'period',
      render: (date) => {
        if (!date) {
          return '---';
        }
        const formattedDate = dayjs(date, 'MMYYYY').format('MMMM YYYY');
        return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
      },
    },
    {
      width: COLUMN_EXTRA_SMALL,
      title: 'Сумма',
      key: 'amount',
      dataIndex: 'amount',
      render: priceRender,
    },
    {
      width: COLUMN_EXTRA_SMALL,
      title: 'Выставлен',
      key: 'confirmation_date',
      dataIndex: 'confirmation_date',
      render: (date) => (date ? dayjs(date).format('DD.MM.YYYY') : '---'),
    },
    {
      width: COLUMN_EXTRA_SMALL,
      title: 'Оплачен',
      key: 'paid_date',
      dataIndex: 'paid_date',
      render: (date) => (date ? dayjs(date).format('DD.MM.YYYY') : '---'),
    },
    {
      width: COLUMN_EXTRA_SMALL,
      title: 'Проведен',
      key: 'send_date',
      dataIndex: 'send_date',
      render: (date) => (date ? dayjs(date).format('DD.MM.YYYY') : '---'),
    },
    {
      dataIndex: 'id',
      title: 'ID  ',
      key: 'id',
      width: COLUMN_EXTRA_SMALL,
    },
  ];

  const [bccExpandedKey, setBccExpandedKey] = useState([]);
  const [bccActiveRowRegisters, setBccActiveRowRegisters] = useState([]);

  const renderBccRegistersTable = () => {
    return (
      <Table
        className="nested-table"
        columns={bccNestedColumns}
        rowKey="iin"
        dataSource={bccActiveRowRegisters}
        tableLayout="fixed"
        pagination={false}
      />
    );
  };

  const handleBccRowExpand = (expanded, record) => {
    if (expanded) {
      setBccActiveRowRegisters(record?.register);
      setBccExpandedKey([record.id]);
    } else {
      setBccExpandedKey([]);
    }
  };

  return (
    <Drawer width="70%" title={title} open={open} onClose={onClose}>
      <Space.Compact direction="vertical">
        <Typography.Text style={{ fontWeight: 700, fontSize: '20px' }}>
          Платеж
        </Typography.Text>
        <Typography.Text type="secondary">
          Ознакомьтесь со статусами карточного платежа
        </Typography.Text>
      </Space.Compact>

      {stepsData && (
        <div style={{ overflowX: 'auto' }}>
          <StepsContainer width={stepsData?.length}>
            <div className="container">
              <Steps
                items={stepsData}
                style={{ marginTop: '24px', overflow: 'visible' }}
              />
            </div>
          </StepsContainer>
        </div>
      )}

      <Divider />

      <Space.Compact direction="vertical">
        <Typography.Text style={{ fontWeight: 700, fontSize: '20px' }}>
          Отправка налогов
        </Typography.Text>
        <Typography.Text type="secondary">
          Ниже предоставлены налоги и их статусы, которые входят в карточный
          платеж
        </Typography.Text>
      </Space.Compact>

      <Table
        style={{ marginTop: '24px' }}
        scroll={{ x: 1000 }}
        dataSource={paymentsInfo.payments ?? []}
        columns={columns}
        rowKey="id"
        expandable={{
          expandedRowRender: renderBccRegistersTable,
          onExpand: handleBccRowExpand,
          expandedRowKeys: bccExpandedKey,
        }}
      />

      <Divider />
      <Space.Compact direction="vertical">
        <Typography.Text style={{ fontWeight: 700, fontSize: '20px' }}>
          Дополнительные данные
        </Typography.Text>

        <Typography.Text type="secondary" style={{ marginTop: '24px' }}>
          № &nbsp;
          <Typography.Text>:&nbsp; {activeRecord?.order}</Typography.Text>
        </Typography.Text>
      </Space.Compact>
    </Drawer>
  );
}

export { PayedTaxesDrawer };
